module.exports = __webpack_public_path__ + "img/case-logo-50.54b675fe.png";